/**
 * What the Monthly Calculator's Save writes (contractsService.updateContract payload).
 *
 * The corrected monthly rate and the rate schedule go out ONLY when the user changed them in the
 * calculator (compared with what it opened with). They used to be sent on every Save but were never
 * written (CON-02); sending the opened values back on every Save would now overwrite a rent the
 * engine learned from Ejar meanwhile. The month rows are computed by the calculator as before.
 */

const num = (v) => parseFloat(v) || 0;

/** What the calculator opened with, to tell later which of rate / schedule the user changed. */
export const openedRateState = (rate, schedule) => ({ rate: num(rate), schedule: JSON.stringify(schedule || []) });

export const calculatorSavePayload = ({ rows, netBalance, rate, schedule, opened, invoice = {}, pickupKM, comments, addons }) => {
    const net = parseFloat(num(netBalance).toFixed(2));
    const payload = {
        monthly_calculations: rows,
        net_balance: net,
        netBalance: net,
        'Net Balance': net,
        invoiceCompanyName: invoice.companyName,
        invoiceCompanyAddress: invoice.companyAddress,
        invoiceCompanyTRN: invoice.companyTRN,
        invoiceKMLimit: invoice.kmLimit,
        pickupKM,
        comments,
        addons,
    };
    const before = opened || openedRateState(0, []);
    if (num(rate) > 0 && Math.abs(num(rate) - before.rate) >= 0.005) payload.total_rent = num(rate);
    if (JSON.stringify(schedule || []) !== before.schedule) payload.rate_schedule = schedule || [];
    return payload;
};
